import React, { useState, useRef, useEffect } from "react";
import { Box, Button, TextField } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import SystemAlert from "./SystemAlert";
// In FileUpload.jsx
const Upload = ({
  MAX_FILESIZE,
  setSnackbarMessage,
  setOpenErrorSnackbar,
  setFilePath,
  onFileSelect,
  fileName,
  setFileName,
  objectUrl,
  resetKey,
}) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertType, setAlertType] = useState("error"); // or "success"
  const [alertMessage, setAlertMessage] = useState("");
  const fileInputRef = useRef(null);

  const allowedTypes = [
    "image/png",
    "image/jpeg", // includes jpg and jpeg
    "application/pdf",
    "application/vnd.ms-excel", // .xls
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
  ];

  // Reset file input when resetKey changes
  useEffect(() => {
    if (fileInputRef.current && resetKey !== undefined) {
      fileInputRef.current.value = "";
    }
  }, [resetKey]);

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];

      if (!allowedTypes.includes(file.type)) {
        const msg =
          "Unsupported file type. Please upload PNG, JPG, PDF, or Excel files.";
        setSnackbarMessage?.(msg);
        setAlertMessage(msg);
        setAlertType("error");
        setAlertOpen(true);
        setOpenErrorSnackbar?.(true);
        return;
      }

      if (file.size > MAX_FILESIZE) {
        const msg = `File size exceeds the ${MAX_FILESIZE / 1048576}MB limit.`;
        setSnackbarMessage?.(msg);
        setAlertMessage(msg);
        setAlertType("error");
        setAlertOpen(true);
        setOpenErrorSnackbar?.(true);
        return;
      }

      setFileName?.(file.name);
      // setFilePath?.(file.name);
      const objectUrl = URL.createObjectURL(file);
      setFilePath?.(objectUrl);
      // console.log("objectUrl upload",objectUrl)
      const reader = new FileReader();
      reader.onload = (event) => {
        const base64 = event.target.result;
        onFileSelect?.(file.name, base64, file);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleSnackbarClose = () => {
    setAlertOpen(false);
  };
  return (
    <>
      <Box sx={styles.box_ipt_file}>
        <Button
          component="label"
          variant="contained"
          startIcon={<AttachFileIcon />}
          sx={{ ...styles.btn_primary }}
        >
          Attach *
          <input
            ref={fileInputRef}
            type="file"
            required
            hidden
            accept=".png,.jpg,.jpeg,.pdf,.xls,.xlsx"
            onChange={handleFileChange}
            name="fileattachment"
          />
        </Button>
        <TextField
          variant="outlined"
          disabled
          fullWidth
          placeholder="File name"
          required
          value={fileName}
          size="small"
          sx={styles.ipt_file_attach}
        />
      </Box>

      <SystemAlert
        open={alertOpen}
        type={alertType}
        message={alertMessage}
        onClose={handleSnackbarClose}
      />
    </>
  );
};

export default Upload;
